import React, { useState, useRef } from "react";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import axiosInstance from "../../src/lib/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "auto",
  marginTop: "50px",
  maxWidth: 500,
  boxShadow: theme.shadows[5],
}));

const Backup = () => {
  const [backupPath, setBackupPath] = useState(
    "E:\\Frontend Directory\\Arti\\tkt_img"
  );
  const [tempPath, setTempPath] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [filePath, setFilePath] = useState("");
  const fileInputRef = useRef(null);
  const UserId = sessionStorage.getItem("UserId");
  const navigate = useNavigate();

  const handleBrowse = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0) {
      // Get the first file to extract the directory path
      const selectedFile = selectedFiles[0];

      // Use webkitRelativePath to get the relative path
      const relativePath = selectedFile.webkitRelativePath;

      // Extract the directory path from the relative path
      const directoryPath = relativePath.substring(
        0,
        relativePath.lastIndexOf("/")
      );

      // Display the full path
      setTempPath(directoryPath); // Update with the full directory path or relative path
    } else {
      toast.info("No files were selected.");
    }
  };

  const handleContinue = async () => {
    const requestData = {
      BackupPath: tempPath + "\\", // Use the temporary path directly
      CreatedBy: UserId,
    };

    try {
      const response = await axiosInstance.post(
        "BackUp/BackupDatabase",
        requestData
      );
      const { data: { Status, Message, Data }, } = response;
      if (Status === 0 && Message) {
        setSuccessMessage(Message); // Set the success message
        setFilePath(Data); // Set the file path
        setBackupPath(Data); // Update backup path with the response data
      }
    } catch (error) {
      toast.error("Backup failed. Please try again.");
    }
  };

  const handleCancel = () => {
    navigate(-1);
    setBackupPath("E:\\Frontend Directory\\Arti\\tkt_img"); // Reset to the dummy path
    setSuccessMessage("");
    setFilePath("");
    setTempPath(""); // Clear the temporary path
  };

  return (
    <StyledPaper>
      <Typography variant="h5" gutterBottom>
        Backup Database
      </Typography>

      <Typography variant="h6" sx={{ alignSelf: "flex-start", mb: 1, mt: 1 }}>
        Backup Path:
      </Typography>
      <TextField
        placeholder="backup path"
        variant="outlined"
        fullWidth
        value={backupPath}
        disabled={true} // Always disable this field
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        <TextField
          placeholder="Selected path will appear here"
          variant="outlined"
          value={tempPath} // Show the full directory path
          sx={{ flexGrow: 1, mr: 1 }}
        />
        <Button variant="contained" onClick={handleBrowse}>
          Browse
        </Button>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
          webkitdirectory=""
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginTop: "50px",
        }}
      >
        <Button variant="contained" onClick={handleContinue}>
          Continue
        </Button>
        <Button variant="outlined" onClick={handleCancel} sx={{ ml: 2 }}>
          Cancel
        </Button>
      </Box>

      {/* Display success message and file path */}
      {successMessage && (
        <Box sx={{ marginTop: 2 }}>
          <Typography variant="body1" color="green">
            {successMessage}
          </Typography>
          {filePath && <Typography variant="body2">{filePath}</Typography>}
        </Box>
      )}
    </StyledPaper>
  );
};

export default Backup;
